import { Stack } from "@mui/material";
import { useEffect } from "react";
import Frame from "./Frame";
import useStore from "./useStore";
import Orientation from "./Orientation";
import Help from "./Help";
import ItemAdd from "./ItemAdd";
import ItemBin from "./ItemBin";
import SaveButton from "./SaveButton";
import API from "../../../services/API";
import { useParams } from "react-router-dom";
import TestButton from "./TestButton";
import ResetButton from "./ResetButton";

export default function Editor(){

    const {id} = useParams()

    const {resetItems, setup} = useStore()

    useEffect(() => {

        API.get(`/courses/${id}/certificate`)
            .then(r => setup(r.data.data))
            .catch(_ => resetItems())
        
    }, [id, resetItems, setup])

    return <Stack spacing={1}>
        
        <Stack direction='row' alignItems='center' spacing={1} flexWrap='wrap'>

            <Orientation />

            <ItemAdd />

            <SaveButton />

            <TestButton />

            <ResetButton />

            <ItemBin />

        </Stack>

        <Frame />

        <Help />

    </Stack>
}


